<template>
    <div class="toggles-root d-flex align-items-center">
        <IconBtn
            name="th"
            :color="!value ? 'secondary' : ''"
            @click.native="handleChange(false)"
        />
        <IconBtn
            class="pr-0"
            name="th-list"
            :color="value ? 'secondary' : ''"
            @click.native="handleChange(true)"
        />
    </div>
</template>

<script>
export default {
    name: 'LayoutToggles',
    props: {
        value: Boolean,
    },
    methods: {
        handleChange(value) {
            this.$emit('input', value);
        },
    },
};
</script>

<style scoped>
.toggles-root {
    height: 20px;
    max-height: 20px;
}
</style>
